import createReducer from 'arts/config/create_reducer';
import Constants from '../config/const';

const getDefaultState = () => ({
  works: [],
  loading: false,
  page: 1
});

const favoriteWorksReducer = createReducer(getDefaultState(), {
  [Constants.favoriteWorks.load]: (state) => ({
    ...state,
    loading: true
  }),
  [Constants.favoriteWorks.success]: (state, { works }) => ({
    ...state,
    works: [...state.works, ...works],
    loading: false,
    page: state.page + 1
  })
});

export default favoriteWorksReducer;
